<template>
    <v-container fluid class="justify-space-between">
        <v-progress-circular indeterminate v-if="!item"></v-progress-circular>
        <div v-else-if="item && item.type === 'wells'" class="flex-grow-1">
            <adapt-result :item="item" :task="predictTask" :optimize-task="wellsTask" v-if="predictTaskFinished"></adapt-result>
        </div>
        <div class="flex-grow-1" v-else>
            <adapt-result :item="item" :task="predictTask" :optimize-task="task" v-if="predictTaskFinished"></adapt-result>
        </div>
    </v-container>
</template>

<script>
import CrudEdit from '@/components/CrudEdit';
import AdaptResult from "@/components/Panels/AdaptResultNew.vue";


export default {
    extends: CrudEdit,
    components: {AdaptResult},
    data() {
        return {
            item: {},
            task: {},
            predictTask: {},
            wellsTask: {},
            uploadType: 'file',
            files: [],
            uploadedFiles: [],
            isSelectingFiles: false,
            ACTION_LOAD: 'problem/loadItems',
            ACTION_NEW: 'problem/newItem',
            ACTION_SAVE: 'problem/saveItem',
            ACTION_SET_EDIT_ITEM: 'problem/setEditItem',
            ROUTE_LIST: 'problemsList',
            STORE_MODULE: 'problem'
        }
    },
    async created() {
        this.$store.commit('task/setOptimizeItem', null);
        this.$store.commit('task/setPredictItem', null);
        this.$store.commit('task/setWellsItem', null);
        this.$store.commit('grid/resetData');
        await this.loadTasks();
    },
    watch: {
        async storeItem() {
            this.item = this.storeItem;
            this.$store.commit('grid/resetData');
            await this.loadTasks();
        },
        storeTask: {
            deep: true,
            handler() {
                if (typeof (this.storeTask) !== 'undefined') {
                    this.task = this.storeTask;
                }
            }
        },
        storePredictTask: {
            deep: true,
            handler() {
                if (typeof (this.storePredictTask) !== 'undefined') {
                    if (!this.storePredictTask?.predict) {
                        return;
                    }
                    this.predictTask = this.storePredictTask;
                }
            }
        },
        storeWellsTask: {
            deep: true,
            handler() {
                if (typeof (this.storeWellsTask) !== 'undefined') {
                    this.wellsTask = this.storeWellsTask;
                }
            }
        },
    },
    methods: {
        async loadTasks() {
            if (this.itemId) {
                if (this.allItems.length === 0) {
                    await this.$store.dispatch(this.ACTION_LOAD);
                    await this.$store.dispatch('task/loadItems', {problemId: this.itemId});
                }

                await this.$store.dispatch(this.ACTION_SET_EDIT_ITEM, this.itemId);
                await this.$store.dispatch('task/setOptimizeItem', this.itemId);
                await this.$store.dispatch('task/setPredictItem', this.itemId);
                await this.$store.dispatch('task/setWellsItem', this.itemId);
            }

            if (this.storeItem) {
                this.item = this.storeItem;
            }

            if (this.storeTask) {
                this.task = this.storeTask;
            }

            if (this.storePredictTask) {
                this.predictTask = this.storePredictTask;
            }

            if (this.storeWellsTask) {
                this.wellsTask = this.storeWellsTask;
            }
        }
    },
    computed: {
        storeTask() {
            return this.$store.state.task.optimize;
        },
        storePredictTask() {
            return this.$store.state.task.predict;
        },
        storeWellsTask() {
            return this.$store.state.task.wells;
        },
        taskFinished() {
            return this.task && this.task.status && this.task.status === 'finished';
        },
        predictTaskFinished() {
            return this.predictTask && this.predictTask.status && this.predictTask.status === 'finished';
        },
        wellsTaskFinished() {
            return this.wellsTask && this.wellsTask.status && this.wellsTask.status === 'finished';
        }
    }
}
</script>

<style scoped>

</style>